
// styles
import styled from 'styled-components';
// components
import { Text, Title } from 'refactored/ui/typography';
import Modal from 'components/layout/Modal';
import { Trans } from 'react-i18next';
import { NonPalletizedModalIcon, PalletizedModalIcon, WarningIcon, CloseIcon } from 'refactored/ui/icons';

const StyledModal = styled(Modal)`
  .modal{
    width: fit-content !important;
  }
  .content {
    padding-bottom: 0 !important;
    width: fit-content;
  }
`;
const ModalContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: calc(648px + 32px);
  h1 {
    width: 648px;
    margin: 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #1C1C1C;
  }
`;
const LoadInfo = styled.div`
  width: calc(50% - 8px); //gap
  outline: 1px solid #E2E8EE;
  border-radius: 8px;
`;
const InfoBox = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  p{
    margin: 0;
    font-family: 'Roboto';
    font-style: normal;
    line-height: 24px;
    color: #54708C;
    font-size: 16px;
    font-weight: 400;
  }
  p:nth-child(2){
    font-weight: 500;
    font-size: 20px;
    margin-top: 16px;
  }
  p:nth-child(3){
    font-weight: 500;
    color: #94A6B8;
  }
  p:nth-child(4){
    margin: 16px 0 8px;
  }
`;
const WarningBox = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  background: #F2F5F8;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #54708C;
`;
const BulletPoint = styled.p`
  ::before{
    content: '·';
    font-size: 20px;
    font-weight: bold;
    margin: 0 8px;
  }
`;
const StyledCloseIcon = styled(CloseIcon)`
  height: 16px;
  width: 16px;
  fill: #94A6B8;
  position: absolute;
  right: 16px;
  cursor: pointer;
`;

const LoadModal = ({t, showModal, setShowModal})=>(
    <StyledModal
              show={showModal}
              size="L"
              closeButton={false}
              withPadding={false}
            >
              <ModalContainer>
                <Title>{t('load_modal.title')}</Title>
                <StyledCloseIcon onClick={() => setShowModal(false)} />
                <LoadInfo>
                  <InfoBox>
                    <PalletizedModalIcon />
                    <Trans
                      t={t}
                      i18nKey="load_modal.palletized"
                      components={{
                        h2: <Text />,
                        subtitle: <Text variant={'label'}/>,
                        bulletpoint: <BulletPoint />,
                      }}
                    />
                  </InfoBox>
                  <WarningBox>
                    <WarningIcon />
                    {t('load_modal.palletized_warning')}
                  </WarningBox>
                </LoadInfo>
                <LoadInfo>
                  <InfoBox>
                    <NonPalletizedModalIcon />
                    <Trans
                      t={t}
                      i18nKey="load_modal.non_palletized"
                      components={{
                        h2: <Text />,
                        subtitle: <Text variant={'label'}/>,
                        bulletpoint: <BulletPoint />,
                      }}
                    />
                  </InfoBox>
                  <WarningBox>
                    <WarningIcon />
                    {t('load_modal.non_palletized_warning')}
                  </WarningBox>
                </LoadInfo>
              </ModalContainer>
            </StyledModal>
)

export default styled(LoadModal)``;